
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/oryggis-og-gaedamal",
      function () {
        return require("private-next-pages/um/fyrirtaekid/oryggis-og-gaedamal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/oryggis-og-gaedamal"])
      });
    }
  